import { NavLink } from "react-router-dom";
import classNames from "classnames";
import { useState } from "react";
import ButtonBehaviour from "components/buttonBehaviour/buttonBehaviour";
import menuIcon from "../../images/menu.svg";
import close from "../../images/close.svg";
import AppleStoreButton from "components/applestorebutton";

export default function Header() {
  const [showMenu, setShowMenu] = useState(false);

  const showMobileMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <header
      className={classNames(`h-[51px] top-0 relative w-full z-40 bg-accent1`, {
        "h-screen": showMenu,
        sticky: showMenu,
      })}
    >
      <div
        className={classNames(
          "w-full h-screen absolute top-0 left-0 bg-whiteColor flex flex-col justify-center pl-20 pr-20",
          {
            hidden: !showMenu,
            relative: !showMenu,
          }
        )}
      >
        <ul className="h-full flex flex-col justify-between max-h-[300px] relative">
          <button>
            <NavLink
              className={({ isActive }) =>
                classNames("button", isActive ? "focused" : "")
              }
              end
              to="/"
              onClick={() => {
                showMobileMenu();
              }}
            >
              Home
            </NavLink>
          </button>
          <button>
            <NavLink
              className={({ isActive }) =>
                classNames("button", isActive ? "focused" : "")
              }
              to="/contact"
              onClick={() => {
                showMobileMenu();
              }}
            >
              Contact
            </NavLink>
          </button>
          <button>
            <NavLink
              className={({ isActive }) =>
                classNames("button", isActive ? "focused" : "")
              }
              to="/privacy"
            >
              Privacy
            </NavLink>
          </button>
        </ul>
      </div>
      <div className="flex items-center h-full justify-between pt-12 lg:pt-20 pb-20 ">
        <div className="h-[60px] w-[800px] hidden lg:block">
          <nav className="hidden lg:block pr-10 pl-10 h-full">
            <ul className="h-full flex items-center justify-start relative">
              <button>
                <NavLink
                  className={({ isActive }) =>
                    classNames("button", isActive ? "focused" : "")
                  }
                  end
                  to="/"
                >
                  <p>Home</p>
                </NavLink>
              </button>
              <button>
                <NavLink
                  className={({ isActive }) =>
                    classNames("button", isActive ? "focused" : "")
                  }
                  to="/contact"
                >
                  <p>Contact</p>
                </NavLink>
              </button>
              <a
                className={classNames("button special focused")}
                href="https://apps.apple.com/gb/app/sono-su-fishing-for-treasure/id6450835384"
              >
                <p>App</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 29 29"
                  fill="currentColor"
                  className="arrowIcon"
                >
                  <path d="M25.5,12.88c-.83,0-1.5.67-1.5,1.5v10.72c0,.5-.4.9-.9.9H3.9c-.5,0-.9-.4-.9-.9V5.9c0-.5.4-.9.9-.9h10.58c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5H3.9C1.75,2,0,3.75,0,5.9v19.2c0,2.15,1.75,3.9,3.9,3.9h19.2c2.15,0,3.9-1.75,3.9-3.9v-10.72c0-.83-.67-1.5-1.5-1.5Z" />
                  <path d="M29,1.5c0-.19-.04-.38-.11-.55,0,0,0-.02,0-.02-.15-.37-.45-.66-.82-.82,0,0-.02,0-.02,0-.17-.07-.35-.11-.55-.11h-8c-.83,0-1.5.67-1.5,1.5s.67,1.5,1.5,1.5h4.38l-11.36,11.36c-.59.59-.59,1.54,0,2.12.29.29.68.44,1.06.44s.77-.15,1.06-.44l11.36-11.36v4.38c0,.83.67,1.5,1.5,1.5s1.5-.67,1.5-1.5V1.5h0s0,0,0,0Z" />
                </svg>
              </a>
            </ul>
          </nav>
        </div>
        <div
          className={classNames(
            "h-[60px] flex flex-col justify-center pr-10 pl-4",
            { hidden: showMenu }
          )}
        >
          <AppleStoreButton />
        </div>
        <div className="absolute right-0 top-0  mt-5 mr-5 z-30 lg:hidden">
          <ButtonBehaviour
            icon={showMenu ? close : menuIcon}
            onSelect={() => showMobileMenu()}
          ></ButtonBehaviour>
        </div>
      </div>
    </header>
  );
}
